const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
};

// Set this to control what gets logged
// In production, you might want to set this to INFO or higher
const CURRENT_LOG_LEVEL = process.env.NODE_ENV === 'production' 
  ? LOG_LEVELS.INFO 
  : LOG_LEVELS.DEBUG;

// Enable this to save logs to localStorage (helpful for debugging redirect flows)
const PERSIST_LOGS = true;
const MAX_PERSISTED_LOGS = 100;

// Helper to save logs to localStorage
const persistLog = (level: string, ...args: any[]) => {
  if (!PERSIST_LOGS) return;
  
  try {
    const logs = JSON.parse(localStorage.getItem('app_logs') || '[]');
    logs.push({
      timestamp: new Date().toISOString(),
      level,
      message: args.map(arg => 
        typeof arg === 'object' ? JSON.stringify(arg) : String(arg)
      ).join(' ')
    });
    
    // Keep only the most recent logs
    while (logs.length > MAX_PERSISTED_LOGS) {
      logs.shift();
    }
    
    localStorage.setItem('app_logs', JSON.stringify(logs));
  } catch (e) {
    // Fail silently - logging should never break the app
  }
};

export const logger = {
  debug: (...args: any[]) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.DEBUG) {
      console.debug('[DEBUG]', ...args);
      persistLog('DEBUG', ...args);
    }
  },
  
  info: (...args: any[]) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.INFO) {
      console.info('[INFO]', ...args);
      persistLog('INFO', ...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.WARN) {
      console.warn('[WARN]', ...args);
      persistLog('WARN', ...args);
    }
  },
  
  error: (...args: any[]) => {
    if (CURRENT_LOG_LEVEL <= LOG_LEVELS.ERROR) {
      console.error('[ERROR]', ...args);
      persistLog('ERROR', ...args);
    }
  },
  
  // Helper to retrieve persisted logs (useful for debugging)
  getLogs: () => {
    try {
      return JSON.parse(localStorage.getItem('app_logs') || '[]');
    } catch (e) {
      return [];
    }
  },
  
  // Helper to clear persisted logs
  clearLogs: () => {
    localStorage.removeItem('app_logs');
  }
}; 